import { HttpContext, HttpContextToken } from '@angular/common/http';

/** Opt-in flag: the Keycloak bearer interceptor only attaches the token when this is set. */
export const ADD_BEARER_TOKEN = new HttpContextToken<boolean>(() => false);

/** Opts a request into the Keycloak bearer interceptor. */
export function withBearerToken(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(ADD_BEARER_TOKEN, true);
}
